import axiosInstance from '../axiosInterceptor/axiosInstance'

const sendSupportEmail = async (data) => {
  const url = '/support/support-email'
  return axiosInstance.post(url, data)
}

export default sendSupportEmail
